import { filter } from 'lodash';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  Stack,
  Button,
  styled,
  MenuItem,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Box
} from '@material-ui/core';

import moment from 'moment';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import CreateIcon from '@material-ui/icons/Create';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useClaimsContext } from '../../context/claims_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const TABLE_HEAD = [
  { id: 'refId', label: 'Seq #', alignRight: true },
  { id: 'ecs', label: 'EC #', alignRight: false },
  { id: 'ids', label: 'ID #', alignRight: false },
  { id: 'deds', label: 'DED', alignRight: false },
  { id: 'payeeco', label: 'Payee Code', alignRight: true },
  { id: 'startd', label: 'Start Date', alignRight: true },
  { id: 'endda', label: 'End Date', alignRight: true },
  { id: 'amt', label: 'Amount', alignRight: true },
  { id: 'file', label: 'Filename', alignRight: false },
  { id: 'stat', label: 'Status', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function PendingSubmission() {
  const { setBatchNo, clearBatch, setCurrentBatch } = useClaimsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [status, setStatus] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();

  useEffect(() => {
    GetSsbProcesses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const GetSsbProcesses = async () => {
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetPendingSSbRecords?status=${status}`).then(
      (res) => {
        setLoading(false);
        console.log('returned GetPendingSSbRecords', res);
        setDataList(res.data);
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const handleBatchDelete = async (e) => {
    console.log('e here', e.batchID);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/ssb/deleteBatch?batchId=${e.batchID}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting Batch!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Batch Deleted Successfully!`, 'success');
          navigate(-1);
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Batch!: ${error}`, 'error');
      }
    );
  };

  const handleEditView = (e) => {
    openEdit(e.row.refId);
  };

  const openNew = () => {
    // clearBatch();
    navigate(`/accounts/ssbprocess/0`);
  };

  const openEdit = (e) => {
    console.log('e right', e);
    navigate(`/accounts/ssbprocess/${e}`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const getStatus = (e) => {
    switch (e.status) {
      case 0:
        return 'New';
      case 1:
        return 'Submitted';
      case 2:
        return 'Approved';
      case 3:
        return 'Declined';
      case 4:
        return 'Pending Approved';
      case 5:
        return 'Pending Declined';
      default:
        return 'Unknown';
    }
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10">
        <Typography component="span" variant="h6" gutterBottom>
          SSB Pending Submissions
        </Typography>
        <Box>
          <Grid container spacing={18} direction="row">
            <Grid item xs={12} sm={4}>
              <FormControl>
                <InputLabel id="selectGroupc">SSB Submissin Status</InputLabel>
                <Select
                  labelId="selectGrouplabel"
                  id="groupId"
                  value={status}
                  size="small"
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                >
                  <MenuItem value="0">New</MenuItem>
                  <MenuItem value="1">Submitted</MenuItem>
                  <MenuItem value="2">Approved</MenuItem>
                  <MenuItem value="3">Declined</MenuItem>
                  <MenuItem value="4">Pending Approval</MenuItem>
                  <MenuItem value="5">Pending Declined</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                startIcon={<NoteAddIcon />}
                onClick={() => GetSsbProcesses()}
              >
                Refresh
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Stack>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      refId,
                      ded,
                      employeeNumber,
                      idNumber,
                      fromDate,
                      toDate,
                      payeeCode,
                      status,
                      submissionId,
                      amountInCents,
                      fileName
                    } = row;
                    const isItemSelected = selected.indexOf(refId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={refId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{refId}</TableCell>
                        <TableCell align="left">{employeeNumber}</TableCell>
                        <TableCell align="left">{idNumber}</TableCell>
                        <TableCell align="left">{ded}</TableCell>
                        <TableCell align="left">{payeeCode}</TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {moment(fromDate).isValid() ? moment(fromDate).format('YYYY-MM-DD') : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {moment(toDate).isValid() ? moment(toDate).format('YYYY-MM-DD') : ''}
                        </TableCell>
                        <TableCell align="left">{amountInCents}</TableCell>
                        <TableCell align="left">{fileName}</TableCell>
                        <TableCell align="right">{getStatus({ status })}</TableCell>
                        {/* <TableCell align="right">
                          <IconButton onClick={() => handleEditView({ row })}>
                            <CreateIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell> */}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Scrollbar>

        <TablePagination
          sx={{
            backgroundColor: 'black',
            color: 'white',
            size: 'small'
          }}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
